$(document).ready(function() {

    resizeFeature();

    $(window).resize(function() {

        resizeFeature();

    });
});
function resizeFeature(){
    var max = -1;
    $('.feature').find('.feature-wrapper .feature-content-box').each(
      function(){
        if($(this).outerHeight() > max){
            max = $(this).outerHeight();
        }
      }
    );
    $('.feature').find('.feature-wrapper').each(
      function(){
        $(this).css('height', max+'px');
      }
    );
}

